import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from "@/components/ui/form";

import {
  adminGenerateMatchesFormSchema,
  AdminGenerateMatchesFormSchema,
} from "./schema";

export const AdminGenerateMatchesForm = ({
  onSubmit,
  onCancel,
}: {
  onSubmit: (data: AdminGenerateMatchesFormSchema) => void;
  onCancel: () => void;
}) => {
  const form = useForm<AdminGenerateMatchesFormSchema>({
    resolver: zodResolver(adminGenerateMatchesFormSchema),
    mode: "onChange",
    defaultValues: {
      count: 5,
    },
  });
  return (
    <Form {...form}>
      <form
        className="w-full flex flex-col gap-4"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={form.handleSubmit(onSubmit)}
      >
        <FormField
          control={form.control}
          name="count"
          render={({ field }) => (
            <FormItem>
              <FormLabel required>Number of new matches</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  {...form.register("count", { valueAsNumber: true })}
                  type="number"
                  min={1}
                  step={1}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="h-[1px] bg-[#E4E7EC] w-full" />
        <div className="!mb-1 flex justify-between">
          <Button variant="ghost" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="secondary"
            // eslint-disable-next-line @typescript-eslint/no-misused-promises
            onClick={() => form.handleSubmit(onSubmit)()}
          >
            Generate Matches
          </Button>
        </div>
      </form>
    </Form>
  );
};
